import { Colors, Icon } from "@blueprintjs/core";

import { Flex } from "@/components/layout/flexbox";

interface AlertMessageProps {
  name?: string | null;
  message: string;
}

export function AlertMessage({ name, message }: AlertMessageProps) {
  return (
    <Flex py={24} opacity={0.8}>
      <span>
        <Icon icon="info-sign" size={20} color={Colors.DARK_GRAY5} />
      </span>
      <span style={{ marginLeft: "10px" }}>{` ${name} ${message}`}</span>
    </Flex>
  );
}
